function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { RichTextEditor, Typography } from 'seagull';
import { useOnMount } from "../../hooks/useOnMount";
import { richTextValidation } from 'validators';
import styles from "./ExtraClause.module.scss";
import { connectControllerToRichTextEditor } from "../../utils/react-hook-form.utils";
export default function ExtraClause(_ref) {
  let {
    showAgreementSettingsWarning,
    onValidation
  } = _ref;
  const {
    control,
    formState,
    trigger
  } = useFormContext();
  const validation = richTextValidation('Notes');
  useEffect(() => {
    onValidation(formState.isValid);
  }, [formState, onValidation]);
  useEffect(() => {
    if (showAgreementSettingsWarning) trigger('extraClause');
  }, [showAgreementSettingsWarning, trigger]);
  useOnMount(() => {
    trigger('extraClause');
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    style: {
      paddingBottom: '8px'
    },
    className: styles.text
  }, "Add a note to your agreement (optional)"), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "extraClause",
    rules: validation,
    render: renderProps => /*#__PURE__*/React.createElement(RichTextEditor, _extends({
      editorHeight: 200,
      placeholder: "Add here anything you need that's not specified elsewhere",
      "data-testid": "formling-extra-clause-input"
    }, connectControllerToRichTextEditor(renderProps, {
      alwaysShowErrors: true
    }), validation.dataAttr))
  }));
}